<template>
  <div class="w-full flex items-center justify-between">
    <div class="text-22 font-bold">
      红商学院
    </div>
    <tk-flex
      v-if="isShowRight"
      :gutter="10"
      middle
    >
      <div
        v-if="$route.path !== '/account/mine'"
        class="square-30 flex-center cursor-pointer rounded-8 bg-white"
        @click="$push('/account/mine')"
      >
        <van-icon name="contact-o" />
      </div>
      <div
        v-if="$route.path !== '/exchange/exchange'"
        class="square-30 flex-center cursor-pointer rounded-8 bg-white"
        @click="$push('/exchange/exchange')"
      >
        <van-icon name="bag-o" />
      </div>
      <div
        v-if="$route.path !== '/' && isShowHome"
        class="square-30 flex-center cursor-pointer rounded-8 bg-white"
        @click="onHome"
      >
        <van-icon name="wap-home-o" />
      </div>
    </tk-flex>
  </div>
</template>

<script>
export default {
  name: 'GlobalTitle',
  props: {
    isShowRight: {
      type: Boolean,
      default: true,
    },
    isShowHome: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onHome () {
      this.$cleanHistory()
      this.$replace('/')
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .van-icon-contact-o {
    font-weight: bold !important;
    color: #272636 !important;
  }
  .van-icon-bag-o {
    font-weight: bold !important;
    color: #272636 !important;
  }
  .van-icon-wap-home-o {
    font-weight: bold !important;
    color: #272636 !important;
  }
}
</style>
